<template>
    <router-view/>
    <GlobalLoader/>
    <ConfirmDialog/>
    <Toaster/>
</template>
<script>
import "@/assets/scss/global.scss"
import "@/campaigns/halloween/halloween.scss"
import GlobalLoader from "@/components/GlobalLoader";
import ConfirmDialog from "@/components/ConfirmDialog";
import Toaster from "@/components/toast/Toaster";

export default { components: { Toaster, ConfirmDialog, GlobalLoader } }
</script>
